import { Controller } from '@hotwired/stimulus'
import { toggleClass } from 'utils/toggle_class'

export default class extends Controller {
  initialize() {
    // Based on https://stackoverflow.com/a/56678169/1202488
    const observer = new IntersectionObserver(
      ([e]) => toggleClass(e.target, "-stuck", e.intersectionRatio < 1),
      {threshold: [1]}
    )

    observer.observe(this.element)
  }
}
